import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen" style={{
    backgroundColor: '#faf7f2'
  }} data-id="element-378">
      <HeroSection data-id="element-379" />
      <HookSection data-id="element-380" />
      <ProblemSection data-id="element-381" />
      <WhyFailedSection data-id="element-382" />
      <MechanismSection data-id="element-383" />
      <WhatYouGetSection data-id="element-384" />
      <WhoIsForSection data-id="element-385" />
      <HowItWorksSection data-id="element-386" />
      <ProofSection data-id="element-387" />
      <FAQSection data-id="element-388" />
      <FinalCTASection data-id="element-389" />
      <Footer data-id="element-390" />
    </main>;
}